import { isNil } from 'lodash'

const addParameters = (path, parameters) => {
  const params = new URLSearchParams(
    Object.fromEntries(Object.entries(parameters).filter(([, value]) => !isNil(value))),
  )
  const qs = params.toString()

  return qs ? `${path}${process.env.REACT_APP_AUGMENTT_API_URL.includes('?') ? '&' : '?'}${qs}` : path
}

export default addParameters
